import type { DefaultOptionType } from 'antd/lib/select/index.d';

// 真实选中数据存储信息
export interface SelectedMemberInfoType extends DefaultOptionType {
  /** 代码补充，与value值一致 */
  key: string;
  value: string;
  label: string;
  /** 负责人icon */
  avatar?: string;
  type: DepartmentMemberOrgEnum;
}
export interface MemberSelectModalProps {
  avatar?: string;
  key: string;
  label: string;
  value: string;
  type: string;
}

export interface MemberSelectModalProps {
  avatar?: string;
  key: string;
  label: string;
  value: string;
  type: string;
}

// 弹窗需要的配置信息
export interface SelectModalConfigType {
  // 弹窗标题， 默认‘选择成员’
  modalTitle?: string;
  // 右侧已选择提示语， 默认‘已选择：’
  modalSelectedTip?: string;
  // 值是否是单选, 默认为false
  isSingleSelected?: boolean;
}
/** 用户与部门-数据类型 */
export enum DepartmentMemberOrgEnum {
  USER = 0, // 用户
  DEPARTMENT = 1, // 部门
  ORG = 2, // 组织
}

export interface DepartmentType {
  avatar?: string;
  /** id */
  key: string;
  value: string;
  /** 名字 */
  label: string;
  /** 类型 */
  type: DepartmentMemberOrgEnum;
  disabled: boolean;
}
export interface UserType {
  avatar?: string;
  /** id */
  key: string;
  /** 名字 */
  label: string;
  disabled: boolean;
  value: string;
  /** 类型 */
  type: DepartmentMemberOrgEnum;
}
export enum EMemberType {
  USER = 0,
  DEPARTMENT = 1,
  ORG = 2,
}
